export default __webpack_public_path__ + "static/og-image-6ea7f0045ad03d797d8d64d042527cdb.jpg";